import { FC, ReactNode, useMemo } from 'react';
import { IntlContext } from '@spa/lib/react/context/IntlContext';
import { TranslationsByIdByNamespace } from '@spa/lib/i18n/common/TranslationsByIdByNamespace';

export interface Props {
  readonly children: ReactNode;
  readonly translationsByIdByNamespace: TranslationsByIdByNamespace;
  readonly enableWarnings?: boolean;
}

const IntlProvider: FC<Props> = ({ children, enableWarnings, translationsByIdByNamespace }) => {
  const intlContextValue = useMemo(() => {
    return {
      translationsByIdByNamespace,
      enableWarnings: enableWarnings ?? true
    };
  }, [enableWarnings, translationsByIdByNamespace]);

  return <IntlContext value={intlContextValue}>{children}</IntlContext>;
};

export default IntlProvider;
